import { motion } from "framer-motion";

// export default function Ourservices() {
//   return (
//     <div className="px-8 scroll-mt-[160px]" id="services">
//       {/* Section Title */}
//       <h1 className="mt-40 text-center text-red-500 font-bold text-3xl">
//         Our Services
//       </h1>

//       <div className="flex justify-center gap-5 mt-5">
//         <div>
//           <img
//             src={require("./Our Services.png")}
//             alt="logo"
//             className="h-[70vh] w-[180vh]"
//           />
//         </div>

//         <div className="mt-5">
//           <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
//             {[
//               {
//                 id: "01",
//                 title: "Snake Control",
//                 desc: "Snake treatments are used to deter snakes from entering homes, gardens, or commercial areas.",
//               },
//               {
//                 id: "02",
//                 title: "Mosquito Control",
//                 desc: "Mosquito control services help eliminate breeding grounds and reduce infestation effectively.",
//               },
//               {
//                 id: "03",
//                 title: "Bed Bug Control",
//                 desc: "Professional bed bug control services help eliminate infestations and prevent their return.",
//               },
//               {
//                 id: "04",
//                 title: "Wasp & Spider Control",
//                 desc: "Professional wasp control services ensure safe removal and prevention.",
//               },
//               {
//                 id: "05",
//                 title: "Rat Control",
//                 desc: "Professional rat control services ensure safe and effective removal to protect your home and business.",
//               },
//               {
//                 id: "06",
//                 title: "Fly Control",
//                 desc: "Professional fly control services help eliminate infestations and protect wood surfaces.",
//               },
//               {
//                 id: "07",
//                 title: "Bee – Hive Removal",
//                 desc: "Professional bee hive removal services ensure safe relocation or extermination while protecting property.",
//               },
//               {
//                 id: "08",
//                 title: "General Pest Control",
//                 desc: "General Pest Control Services ensure safe and long-term elimination of all common household pests.",
//               },
//               {
//                 id: "09",
//                 title: "Ant & Silverfish Control",
//                 desc: "Eliminate infestations and prevent future problems using safe and effective treatments.",
//               },
//               {
//                 id: "10",
//                 title: "Cockroach Control",
//                 desc: "Cockroach control services ensure safe and long-term elimination of cockroach infestations.",
//               },
//               {
//                 id: "11",
//                 title: "Lizard Control",
//                 desc: "Lizard control services help eliminate them safely and prevent re-infestation.",
//               },
//               {
//                 id: "12",
//                 title: "Housefly & Sand Fly Control",
//                 desc: "Fly control services ensure their elimination and long-term prevention.",
//               },
//               {
//                 id: "13",
//                 title: "Weed Borer Control",
//                 desc: "Weed Borer control services help eliminate weeds effectively and prevent their regrowth.",
//               },
//               {
//                 id: "14",
//                 title: "Termite Control",
//                 desc: "Anti-termite treatment ensures complete elimination and long-term protection against termite infestations.",
//               },
//               {
//                 id: "15",
//                 title: "Bird Netting Service",
//                 desc: "Bird netting services provide an effective and humane solution to prevent birds from entering unwanted areas.",
//               },
//             ].map((service, index) => (
//               <div key={index} className="flex gap-3 items-start">
//                 <h1 className="text-3xl text-red-500">{service.id}</h1>
//                 <div>
//                   <h3 className="font-semibold hover:text-red-500">
//                     {service.title}
//                   </h3>
//                   <p className="text-sm">{service.desc}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

export default function Ourservices() {
  return (
    <div className="px-4 sm:px-6 lg:px-8 scroll-mt-[160px]" id="services">
      {/* Section Title */}
      <h1 className="mt-40 text-center text-red-500 font-bold text-3xl">
        Our Services
      </h1>

      {/* Responsive Layout */}
      <div className="flex flex-col lg:flex-row items-center lg:items-start lg:justify-center gap-10 mt-10">
        {/* Image Section */}
        <div className="w-full lg:w-auto">
          <motion.img
            whileHover={{ scale: 1.08 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
            src={require("./Our Services.png")}
            alt="Our Services"
            className="w-full max-w-full lg:w-[110vh] lg:h-[70vh] object-cover cursor-pointer"
          />
        </div>

        {/* Services List */}
        <div className="w-full">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              {
                id: "01",
                title: "Snake Control",
                desc: "Snake treatments are used to deter snakes from entering homes, gardens, or commercial areas.",
              },
              {
                id: "02",
                title: "Mosquito Control",
                desc: "Mosquito control services help eliminate breeding grounds and reduce infestation effectively.",
              },
              {
                id: "03",
                title: "Bed Bug Control",
                desc: "Professional bed bug control services help eliminate infestations and prevent their return.",
              },
              {
                id: "04",
                title: "Wasp & Spider Control",
                desc: "Professional wasp and spider control services ensure safe removal and prevention.",
              },
              {
                id: "05",
                title: "Rat Control",
                desc: "Professional rat control services ensure safe and effective removal to protect your home and business.",
              },
              {
                id: "06",
                title: "Fly Control",
                desc: "Help eliminate infestations and reduce health risks.",
              },
              {
                id: "07",
                title: "Beehive Removal",
                desc: "Professional bee hive removal services ensure safe relocation or extermination while protecting property.",
              },
              {
                id: "08",
                title: "General Pest Control",
                desc: "General Pest Control Services ensure safe and long-term elimination of all common household pests.",
              },
              {
                id: "09",
                title: "Ant & Silverfish Control",
                desc: "Eliminate infestations and prevent future problems using safe and effective treatments.",
              },
              {
                id: "10",
                title: "Cockroach Control",
                desc: "Cockroach control services ensure safe and long-term elimination of cockroach infestations.",
              },
              {
                id: "11",
                title: "Lizard Control",
                desc: "Lizard control services help eliminate them safely and prevent re-infestation.",
              },
              {
                id: "12",
                title: "Housefly & Sand Fly Control",
                desc: "Housefly and sand fly control services ensure effective elimination and long-term prevention.",
              },
              {
                id: "13",
                title: "Wood Borer Control",
                desc: "Wood Borer Control services help eliminate weeds effectively and prevent their regrowth.",
              },
              {
                id: "14",
                title: "Termite Control",
                desc: "Anti-termite treatment ensures complete elimination and long-term protection against termite infestations.",
              },
              {
                id: "15",
                title: "Bird Netting Service",
                desc: "Bird netting services provide an effective and humane solution to prevent birds from entering unwanted areas.",
              },
            ].map((service, index) => (
              <div key={index} className="flex gap-3 items-start">
                <h1 className="text-2xl text-red-500 font-bold">
                  {service.id}
                </h1>
                <div>
                  <h3 className="font-semibold hover:text-red-500 text-base">
                    {service.title}
                  </h3>
                  <p className="text-sm text-gray-700">{service.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
